<template>
  <div class="absolute inset-0 size-full" :class="stylesMap[severity]" />
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    severity?: 'primary' | 'secondary' | 'primary_solid'
  }>(),
  {
    severity: 'primary'
  }
)

const stylesMap: Record<(typeof props)['severity'], string> = {
  primary: 'bg-gradient-primary',
  primary_solid: 'bg-gradient-primary-solid',
  secondary: 'bg-gradient-secondary'
}
</script>
